import flagsmith from '@flagsmith/flagsmith'
import { FLAGSMITH_ENVIRONMENT_ID, ENV } from '@/app/core/env'

/**
 * Flags conocidas del proyecto. Agregar aca cada nueva flag para tener
 * autocompletado y type-safety en `isEnabled` / `getValue`.
 */
export type KnownFlag = 'new_payment_slips' | 'payroll_paid' | 'new_bank_files'

let initialised = false

/**
 * Inicializa el SDK de Flagsmith una unica vez.
 * @param onChange callback disparado por Flagsmith cada vez que cambian las
 * flags (respuesta del server, cache, cambio de identity). Se usa para
 * re-sincronizar el store reactivo de Vue.
 */
export async function initFeatureFlags(onChange: () => void): Promise<void> {
  if (initialised) return
  await flagsmith.init({
    environmentID: FLAGSMITH_ENVIRONMENT_ID[ENV()](),
    cacheFlags: true,
    defaultFlags: {
      new_payment_slips: { enabled: false, value: null },
      payroll_paid: { enabled: false, value: null }
    },
    onChange: () => onChange()
  })
  initialised = true
}

export interface FlagsmithIdentity {
  workspaceId: string
  companyCode: string
  countryIsoCode: string
}

/**
 * Identifica el contexto de evaluacion en Flagsmith.
 *
 * La unidad de segmentacion es la COMPANIA dentro del workspace (no el
 * usuario), porque un usuario puede operar sobre multiples companias del
 * tenant. El identity es `${workspaceId}:${companyCode}` y los traits
 * permiten segmentar por workspace, compania y pais.
 *
 * Dispara un fetch de flags para ese identity (Flagsmith cachea por identity
 * en localStorage cuando cacheFlags: true).
 */
export async function identifyFeatureFlags(
  id: FlagsmithIdentity
): Promise<void> {
  if (!id.workspaceId || !id.companyCode) return
  await flagsmith.identify(`${id.workspaceId}:${id.companyCode}`, {
    workspaceId: id.workspaceId,
    companyCode: id.companyCode,
    country: id.countryIsoCode
  })
}

export { flagsmith }
